// removed by extract-text-webpack-plugin
module.exports = {"detailInfoContainer":"_13fDOgIglgTit_qAODW43b","contentInfos":"_2RHxyhxtIKU8hbG0ZXVCd","engContentInfos":"_2u6uX47ziS7N84NMxAI9B0","infoKey":"_3JlkJ83UIHr0bmv7SfWvn1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/content-detail-info/ContentDetailInfo.css
// module id = 388
// module chunks = 0